import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Input from '../../../Input';
import { PopperManager, Popper } from '../../../Popover';
import { ThemeOptions } from '../../../publicSession';
import s from './Dots.scss';
var Dots = function (_a) {
    var totalPages = _a.totalPages, onChangePage = _a.onChangePage, getPageUrl = _a.getPageUrl, _b = _a.startOpen, startOpen = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var _c = useState(startOpen), showPopover = _c[0], setShowPopover = _c[1];
    var _d = useState(), pageNumber = _d[0], setPageNumber = _d[1];
    var isValidPage = !!pageNumber && pageNumber > 0 && pageNumber <= totalPages;
    var onInput = useCallback(function (value) {
        if (value === '' || value === undefined) {
            setPageNumber(undefined);
            return;
        }
        var number = parseInt(value, 10);
        if (!Number.isNaN(number)) {
            setPageNumber(number);
        }
    }, []);
    var closePopover = useCallback(function () { return setShowPopover(false); }, []);
    var onKeyDown = useCallback(function (e) {
        if (e.key === 'Enter') {
            setShowPopover(false);
            onChangePage && onChangePage(pageNumber);
            if (getPageUrl) {
                var url = getPageUrl(pageNumber);
                if (url) {
                    window.location.assign(url);
                }
            }
        }
    }, [getPageUrl, onChangePage, pageNumber]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PopperManager, { renderReference: function (_a) {
                var ref = _a.ref;
                return (React.createElement("button", { className: classnames(s['dots'], showPopover && s['open']), ref: ref, onClick: function () { return setShowPopover(function (show) { return !show; }); } }, "..."));
            } }, showPopover && (React.createElement(Popper, { contentClassName: s['jump-panel'], showArrow: false, forceTheme: ThemeOptions.DARK, placement: "bottom", onClickOutside: closePopover },
            React.createElement("div", { className: s['goto'] }, t('pagination.goToPage')),
            React.createElement(Input, { value: pageNumber ? "" + pageNumber : '', onChange: onInput, onKeyDown: isValidPage ? onKeyDown : undefined, inputClassName: s['input'], skin: {
                    'input-layout-paddings': s['input-paddings'],
                    bar: s['input-bar'],
                }, autoFocus: true }))))));
};
Dots.displayName = 'Dots';
export default Dots;
//# sourceMappingURL=Dots.js.map